import { DocumentData } from "@1games-ru/region-shared/dist/types/documents/documentData";
import clsx from "clsx";

function Field({
  label,
  value,
  className,
  classNameValue,
  classNameLabel,
}: {
  label?: string;
  value: string;
  className?: string;
  classNameValue?: string;
  classNameLabel?: string;
}) {
  const labelComponent = label ? (
    <div className={clsx("text-[#3D4E71] text-15 font-medium pt-1", classNameLabel)}>{label}</div>
  ) : null;

  return (
    <div className={clsx("flex flex-col gap-1 items-start", className)}>
      <div
        className={clsx(
          "border-b border-b-[#3D4E71] text-center text-dark-800 text-15 uppercase pb-2",
          classNameValue,
        )}
      >
        {value}
      </div>
      {labelComponent}
    </div>
  );
}

export default function PoliceEmployee({ docNumber, issuedAt, owner }: DocumentData) {
  return (
    <div
      className="w-[55.625rem] h-[18.75rem] grid grid-cols-2 gap-5 text-[#3D4E71] font-medium bg-[#EEF8FE] rounded-[0.4rem] overflow-clip"
      style={{
        backgroundImage: "url(./svg/documents/mvd-id.webp)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <div className="relative p-[1.875rem] flex items-start">
        <div className="w-full h-full flex flex-col justify-between">
          <div className="w-full flex items-start justify-between gap-5">
            <div className="relative shrink-0 bg-white isolate">
              <img
                src={owner.photo}
                alt=""
                className="w-[7.5rem] h-[8.75rem] border border-[#3D4E71] pointer-events-none"
              />
              <div
                className="absolute -top-[0.3rem] left-0 right-0  h-[0.625rem]"
                style={{
                  backgroundImage: "url(./svg/documents/blue-photo-border-g.svg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                }}
              />
              <div
                className="absolute -top-[0.3rem] -left-[0.3rem] h-[7.5rem] w-[0.625rem]"
                style={{
                  backgroundImage: "url(./svg/documents/blue-photo-border-v.svg)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                }}
              />
              <img
                src="./svg/documents/seal-police.webp"
                alt=""
                className="z-1 w-[6.25rem] aspect-square absolute -right-[4rem] -bottom-[4rem] pointer-events-none -rotate-12"
              />
            </div>
            <div className="grow italic text-18 text-center">МВД РЕГИОНА</div>
          </div>
          <div className="w-full flex items-end gap-5">
            <div className="relative text-15 border-t border-[#3D4E71] pt-1">
              {owner?.signature && (
                <div
                  className="absolute z-1 h-[4rem] -translate-y-[3.5rem] w-fit pointer-events-none"
                  style={{
                    backgroundImage: `url(${owner.signature})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              )}
              Личная подпись
            </div>
            <div className="grow w-[6.25rem] text-right">№ {docNumber}</div>
          </div>
        </div>
      </div>
      <div className="relative p-[1.875rem] flex flex-col gap-5">
        <div className="w-full italic text-15 text-center">
          МИНИСТЕРСТВО ВНУТРЕННИХ ДЕЛ
          <br /> РЕГИОНА
        </div>
        <Field
          value={[owner.lastName, owner.firstName].join(" ")}
          label="Имя Фамилия"
          className="w-full"
          classNameValue="w-full"
        />
        <Field value={owner.rankName} label="Звание" className="w-full" classNameValue="w-full" />
        <div className="absolute bottom-[1.875rem] left-[1.875rem]">
          <div className="text-15">Дата выдачи</div>
          <div className="mt-1 text-dark-800 text-15">{issuedAt}</div>
        </div>
        <img
          src="./svg/documents/seal-police.webp"
          alt=""
          className="absolute z-1 w-[6.25rem] aspect-square pointer-events-none bottom-[1.875rem] right-[1.875rem] rotate-12"
        />
        <img
          src="./svg/dark-signature.svg" // TODO: {issuer.signature}
          className="absolute z-2 h-[4rem] bottom-[1.875rem] right-[1.875rem]"
          alt=""
        />
      </div>
    </div>
  );
}
